export default function CloseEntry() {
    return {
        type: 'HISTORY_ACTION',
        payload: {
            old: [],
            showOld: false,
        }
    };
}



/** WEBPACK FOOTER **
 ** ./src/modules/food/actions/history/CloseEntry.js
 **/